// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__3vTiJ","primary":"Button_primary__1lIy8"};